import React from 'react'

const Footer = () => {
  return (
    <div className="  flex    h-auto  items-center justify-center overscroll-contain    pl-6 text-white shadow">
      <div className="text-center text-xs sm:text-base">
        <div>ほくろによる非公式サイトです</div>
        {/* <div className="sm:flex">
          <p>【お問い合わせ】</p>
          企画：
          <a
            href="https://twitter.com/Duodenana4"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-sky-400"
          >
            12指腸（@Duodenana4 ）
          </a>
          ・ サイト：
          <a
            href="https://twitter.com/chinari819"
            target="_blank"
            rel="noopener noreferrer"
            className=" hover:text-sky-400"
          >
            ちなり（@chinari819）
          </a>
        </div> */}
        <div className="flex">
          <p>お問い合わせ：</p>

          <a
            href="https://twitter.com/chinari819"
            target="_blank"
            rel="noopener noreferrer"
            className=" hover:text-sky-400"
          >
            ちなり（@chinari819）
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
